module.exports = __webpack_public_path__ + "static/media/8.8b867db7.jpg";